import {
  createRootRouteWithContext,
  HeadContent,
  Outlet,
} from "@tanstack/react-router";
import { TanStackRouterDevtools } from "@tanstack/react-router-devtools";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { CssBaseline } from "@mui/material";
import type { RouterContext } from "../main";
import { ToastContainer } from "react-toastify";
import { DefaultErrorComponent } from "../components/DefaultErrorComponent";

// Root component cannot have loader, otherwise it will show a pending component without the layout
export const Route = createRootRouteWithContext<RouterContext>()({
  component: RootComponent,
  errorComponent: import.meta.env.DEV ? undefined : DefaultErrorComponent,
  head: () => ({
    meta: [
      {
        title: "DNA Dashboard",
      },
    ],
  }),
});

function RootComponent() {
  return (
    <>
      <HeadContent />
      <CssBaseline />
      <ToastContainer />
      <Outlet />
      <TanStackRouterDevtools position="bottom-right" />
      <ReactQueryDevtools position="bottom" buttonPosition="bottom-left" />
    </>
  );
}
